module.exports = "../study/imgs/maps/Nagano/S8/Helth/HeatDisorder/Nagano_HeatDisorder_GFDL_RCP45_Mid.png";